<template>
  <div class="login-page">
    <div class="swiper-container">
     <Carousel
        :autoplay="setting.autoplay"
        :autoplay-speed="setting.autoplaySpeed"
        :dots="setting.dots"
        :radius-dot="setting.radiusDot"
        :trigger="setting.trigger"
        :arrow="setting.arrow" :height="770">
        <CarouselItem>
            <div class="demo-carousel"><a class="banner login-banner1" href="#"></a></div>
        </CarouselItem>
      </Carousel>
      <div class="top-wrap">
        <h3 class="logo"><img :src="logo"/>猎上网</h3>
        <div class="login-wrap">
          <h4 class="title">
            <span @click="changeChannel('register')" :class="[type=='register' ? 'cur' : '']">企业HR注册</span>
            <span @click="changeChannel('login')" :class="[type=='login' ? 'cur' : '']">账户登录</span>
          </h4>
          <div v-show="type=='login'" class="login-form">
            <Form :label-width="0" ref="loginForm" :model="formValidate" :rules="ruleValidate">
                <p class="title">手机号</p>
                <FormItem prop="loginName">
                  <Input @on-enter="login" size="large" v-model="formValidate.loginName" :maxlength="20"></Input>
                </FormItem>
                <p v-show="!useMessageLogin" class="title">密码</p>
                <FormItem v-show="!useMessageLogin" prop="passWord">
                  <Input @on-enter="login" size="large" type="password" v-model="formValidate.passWord" :maxlength="20"></Input>
                </FormItem>
                <p class="title">验证码</p>
                <FormItem v-if="type=='login'" prop="obj" style="position: relative;">
                  <!-- <Input size="large" @on-enter="login" v-model="formValidate.imageVeriCode" :maxlength="8"></Input> -->
                  <ali-yun-check @getCheck="getCheckPhone"></ali-yun-check>
                </FormItem>
                <!-- <div v-show="isShowImg || useMessageLogin" class="rel-img-wrap">
                  <div class="form-verify-img"><img :src="vImg" @click="setVerifyImg" /></div>
                </div> -->
                <p v-show="useMessageLogin" class="title">短信验证码</p>
                <FormItem prop="verifyCode" v-show="useMessageLogin">
                  <Input size="large" @on-enter="login" v-model="formValidate.verifyCode" :maxlength="8">
                    </Input>
                </FormItem>
                <div v-show="useMessageLogin" class="rel-img-wrap">
                  <div class="phone-img-wrap">
                    <a v-if="!sending" href="javascript:;" @click="sendCode">获取验证码</a>
                    <a v-else class="unsend" href="javascript:;">{{seconds}}s</a>
                  </div>
                </div>
                <div v-show="!useMessageLogin" class="find-pwd clearfix">
                  <Checkbox class="fl" style="font-size:14px;" v-model="expiredNum">5天内免登录</Checkbox>
                  <a class="fr" target="_blank" href="#/forgot?step=1">忘记密码？</a>
                </div>
            </Form>
            <Button type="primary" style="width:340px;color:#2d8cf0;font-size:16px;background:#fff;border-radius:31px;font-weight:bold;" :loading="loading" @click="login" size="large">立即登录</Button>
            <a class="text-bottom underline" href="javascript:;" v-if="!useMessageLogin" @click="changeLoginType(1)">通过短信验证码登录</a>
            <a class="text-bottom underline" href="javascript:;" v-if="useMessageLogin" @click="changeLoginType(0)">通过密码登录</a>
          </div>
          <div v-show="type=='register'" class="login-form">
            <Form :label-width="0" ref="registerForm" :model="registerValidate" :rules="ruleValidate2">
                <p class="title">手机号</p>
                <FormItem prop="loginName2">
                      <Input @on-enter="register" size="large" v-model="registerValidate.loginName2" :maxlength="20"></Input>
                </FormItem>
                <p class="title">图片验证码</p>
                <FormItem v-if="type=='register'" prop="obj">
                    <!-- <Input size="large" @on-enter="register" v-model="registerValidate.imageVeriCode2" :maxlength="8"></Input> -->
                    <ali-yun-check @getCheck="getCheckCode"></ali-yun-check>
                </FormItem>
                <!-- <div class="rel-img-wrap">
                    <div class="form-verify-img"><img :src="vImg" @click="setVerifyImg" /></div>
                </div> -->
                <p class="title">短信验证码</p>
                <FormItem prop="verifyCode2">
                    <Input size="large" @on-enter="register" v-model="registerValidate.verifyCode2" :maxlength="8">
                    </Input>
                </FormItem>
                <div class="rel-img-wrap">
                    <div class="phone-img-wrap">
                      <a v-if="!sending2" href="javascript:;" @click="sendRegisterCode">获取验证码</a>
                      <a v-else class="unsend" href="javascript:;">{{seconds2}}s</a>
                    </div>
                </div>
            </Form>
            <Button type="primary" style="width:340px;color:#2d8cf0;font-size:16px;background:#fff;border-radius:31px;font-weight:bold;" :loading="loading" @click="register" size="large">下一步</Button>
            <div class="text-bottom">注册代表你已经同意<a href="//info.hunteron.com/protocol/pc/hr.html" target="_blank">猎上用户协议</a></div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="banner-wrap" :style="{backgroundImage: topBg}">
      <a :href="imgHref" class="banner-link" target="_blank">
      </a>
    </div> -->
    <info></info>
  </div>
</template>

<script>
import DB from "@/common/db";
import MD5 from "@/common/md5";
import info from "./info";
import logo from "@/assets/logo.png";

export default {
  name: "login",
  data() {
    const validateImg = (rule, value, cb) => {
      if (this.tempError1) {
        this.tempError1 = false;
        return cb();
      } else if (!value && (this.isShowImg || this.useMessageLogin)) {
        cb(new Error("请填写图片验证码"));
      } else if (this.showServerError && this.loginImageCodeError) {
        this.showServerError = false;
        cb(new Error(this.loginImageCodeError));
      } else {
        cb();
      }
    };
    const validateCode = (rule, value, cb) => {
      if (this.tempError2) {
        this.tempError2 = false;
        return cb();
      } else if (!value && this.useMessageLogin) {
        cb(new Error("请填写短信验证码"));
      } else if (this.showServerError && this.loginPhoneCodeError) {
        this.showServerError = false;
        cb(new Error(this.loginPhoneCodeError));
      } else {
        cb();
      }
    };
    const validateImg2 = (rule, value, cb) => {
      if (this.tempError3) {
        this.tempError3 = false;
        return cb();
      } else if (!value) {
        cb(new Error("请填写图片验证码"));
      } else if (this.showServerError && this.registerImageCodeError) {
        this.showServerError = false;
        cb(new Error(this.registerImageCodeError));
      } else {
        cb();
      }
    };
    const validateCode2 = (rule, value, cb) => {
      if (this.tempError4) {
        this.tempError4 = false;
        return cb();
      } else if (!value) {
        cb(new Error("请填写短信验证码"));
      } else if (this.showServerError && this.registerPhoneCodeError) {
        this.showServerError = false;
        cb(new Error(this.registerPhoneCodeError));
      } else {
        cb();
      }
    };
    const validatePwd = (rule, value, cb) => {
      if (this.tempError5) {
        this.tempError5 = false;
        return cb();
      } else if (!value && !this.useMessageLogin) {
        cb(new Error("请填写密码"));
      } else {
        cb();
      }
    };
    const validateLoginName = (rule, value, cb) => {
      if (this.tempError6) {
        this.tempError6 = false;
        return cb();
      } else if (this.tempError7) {
        this.tempError7 = false;
        return cb();
      } else if (!value) {
        return cb(new Error("请填写手机号"));
      } else if (
        (this.useMessageLogin || this.type == "register") &&
        !this.phoneReg.test(value)
      ) {
        return cb(new Error("请填写正确的格式"));
      } else if (this.showServerError && this.loginNameError) {
        this.showServerError = false;
        cb(new Error(this.loginNameError));
      } else if (this.showServerError && this.registerNameError) {
        this.showServerError = false;
        cb(new Error(this.registerNameError));
      } else {
        return cb();
      }
    };

    return {
      setting: {
        autoplay: false,
        autoplaySpeed: 3000,
        dots: "none",
        radiusDot: false,
        trigger: "click",
        arrow: "never"
      },
      showServerError: false, //是否显示服务器端报错
      loginNameError: "", //登录时用户名错误信息
      loginImageCodeError: "", //登录时图片验证码错误信息
      loginPhoneCodeError: "", //登录时短信验证码错误信息
      loginPasswordError: "", //登录时密码错误信息
      registerNameError: "", //注册时用户名错误信息
      registerImageCodeError: "", //注册时图片验证码错误信息
      registerPhoneCodeError: "", //注册时短信验证码错误信息
      tempError1: false,
      tempError2: false,
      tempError3: false,
      tempError4: false,
      tempError5: false,
      tempError6: false,
      tempError7: false,
      topBg: "",
      imgHref: "",
      logo: logo,
      type: this.$route.query.type ? this.$route.query.type : "login",
      useMessageLogin: false, //是否是短信验证码登录
      expiredNum: false, //是否5天内免登陆
      sending: false,
      seconds: 0,
      sending2: false,
      seconds2: 0,
      phoneReg: /^1[0-9]{10}$/,
      saleAdmin: this.$route.query.saleAdmin ? this.$route.query.saleAdmin : "",
      formValidate: {
        loginName: null,
        passWord: null,
        imageVeriCode: null,
        verifyCode: null,
        obj: null
      },
      registerValidate: {
        loginName2: null,
        imageVeriCode2: null,
        verifyCode2: null,
        obj: null
      },
      ruleValidate: {
        loginName: { validator: validateLoginName, trigger: "blur" },
        passWord: { validator: validatePwd, trigger: "blur" },
        // imageVeriCode: { validator: validat   eImg, trigger: "blur" },
        obj: {required: true, message: '请滑动验证码'},
        verifyCode: { validator: validateCode, trigger: "blur" }
      },
      ruleValidate2: {
        loginName2: [{ validator: validateLoginName, trigger: "blur" }],
        // imageVeriCode2: { validator: validateImg2, trigger: "blur" },
        obj: {required: true, message: '请滑动验证码'},
        verifyCode2: { validator: validateCode2, trigger: "blur" }
      },
      loading: false,
      vImg: null,
      isShowImg: false
    };
  },
  components: {
    info,
    'aliYunCheck': resolve => require(['@/components/aliYunCheck'], resolve)
  },
  methods: {
    getCheckCode(data){
      this.registerValidate.obj = data && Object.keys(data).length ? {...data} : null;
      if(this.registerValidate.obj){
        this.$refs.registerForm.validateField("obj");
      }
    },
    getCheckPhone(data){
      this.formValidate.obj = data && Object.keys(data).length ? {...data} : null;
      if(this.formValidate.obj){
        this.$refs.loginForm.validateField("obj");
      }
    },
    changeLoginType(type) {
      this.useMessageLogin = type == "1" ? true : false;
      this.loginNameError = "";
      this.loginImageCodeError = "";
      this.loginPhoneCodeError = "";
      this.loginPasswordError = "";
      this.tempError1 = true;
      this.tempError2 = true;
      this.tempError3 = true;
      this.tempError4 = true;
      this.tempError5 = true;
      this.tempError6 = true;
      this.tempError7 = true;
      this.formValidate.imageVeriCode = null;
      this.formValidate.verifyCode = null;
      this.$refs["registerForm"].validate(valid => {});
      this.$refs["loginForm"].validate(valid => {});
    },
    changeChannel(type) {
      this.type = type;
      this.loginNameError = "";
      this.loginPasswordError = "";
      this.loginImageCodeError = "";
      this.loginPhoneCodeError = "";
      this.registerNameError = "";
      this.registerImageCodeError = "";
      this.registerPhoneCodeError = "";
      this.registerValidate.loginName2 = null;
      this.registerValidate.verifyCode2 = null;
      this.registerValidate.imageVeriCode2 = null;
      this.formValidate.imageVeriCode = null;
      this.formValidate.verifyCode = null;
      this.tempError1 = true;
      this.tempError2 = true;
      this.tempError3 = true;
      this.tempError4 = true;
      this.tempError5 = true;
      this.tempError6 = true;
      this.tempError7 = true;
      this.$refs["registerForm"].validate(valid => {});
      this.$refs["loginForm"].validate(valid => {});
    },
    sendRegisterCode() {
      if (this.seconds2 > 0) {
        return;
      }
      if (
        !this.registerValidate.loginName2 ||
        !this.phoneReg.test(this.registerValidate.loginName2)
      ) {
        this.$refs.registerForm.validateField("loginName2");
        return;
      }
      if (!this.registerValidate.obj || !Object.keys(this.registerValidate.obj).length) {
        this.$refs.registerForm.validateField("obj");
        return;
      }
      this.tempError3 = true;
      this.tempError4 = true;
      this.tempError6 = true;
      this.registerPhoneCodeError = "";
      this.registerImageCodeError = "";
      this.registerNameError = "";
      this.$refs.registerForm.validateField("loginName2");
      this.$refs.registerForm.validateField("obj");
      this.$refs.registerForm.validateField("verifyCode2");
      this.seconds2 = 30;
      DB.request({
        url: DB.prefix + "auth/v2/sendRegistPhone",
        type: "post",
        showMessage: false,
        data: {
          phone: this.registerValidate.loginName2,
          ...this.registerValidate.obj
        },
        success: res => {
          this.sending2 = true;
          let intervalTimer = setInterval(() => {
            this.seconds2--;
            if (this.seconds2 < 1) {
              this.sending2 = false;
              clearInterval(intervalTimer);
            }
          }, 1000);
        },
        error: data => {
          this.seconds2 = 0;
          this.setVerifyImg();
          if (data.errCode == "hr5005") {
            //手机号已经存在
            this.showServerError = true;
            this.registerNameError = data.message;
            this.$refs.registerForm.validateField("loginName2");
            return false;
          } else if (data.errCode == "hr0003") {
            //图片验证码验证失败
            this.showServerError = true;
            this.registerImageCodeError = data.message;
            this.$refs.registerForm.validateField("obj");
            return false;
          }
        },
        complete: () => {}
      });
    },
    sendCode() {
      if (this.seconds > 0) {
        return;
      }
      if (
        !this.formValidate.loginName ||
        !this.phoneReg.test(this.formValidate.loginName)
      ) {
        this.$refs.loginForm.validateField("loginName");
        return;
      }
      if (!this.formValidate.obj || !Object.keys(this.formValidate.obj).length) {
        this.$refs.loginForm.validateField("obj");
        return;
      }
      this.tempError1 = true;
      this.tempError2 = true;
      this.tempError6 = true;
      this.loginNameError = "";
      this.loginImageCodeError = "";
      this.loginPhoneCodeError = "";
      this.$refs.loginForm.validateField("loginName");
      this.$refs.loginForm.validateField("verifyCode");
      this.$refs.loginForm.validateField("obj");
      this.seconds = 30;
      DB.request({
        url: DB.prefix + "auth/v2/sendSmsLogin",
        type: "post",
        showMessage: false,
        data: {
          mobilePhone: this.formValidate.loginName,
          // imageVerifyCode: this.formValidate.imageVeriCode
          ...this.formValidate.obj
        },
        success: res => {
          this.sending = true;
          let intervalTimer = setInterval(() => {
            this.seconds--;
            if (this.seconds < 1) {
              this.sending = false;
              clearInterval(intervalTimer);
            }
          }, 1000);
        },
        error: data => {
          this.seconds = 0;
          this.setVerifyImg();
          if (data.errCode == "hr5007") {
            //手机号不存在
            this.showServerError = true;
            this.loginNameError = data.message;
            this.$refs.loginForm.validateField("loginName");
            return false;
          } else if (data.errCode == "hr0003") {
            //图片验证码验证失败
            this.showServerError = true;
            this.loginImageCodeError = data.message;
            this.$refs.loginForm.validateField("obj");
            return false;
          }
        },
        complete: () => {}
      });
    },
    setVerifyImg() {
      // this.vImg =
      //   DB.prefix + "common/v2/imageVerCode?st=" + new Date().getTime();
      if(window.nc){
        window.nc.reset();
      }
    },
    checkVerifyImg() {
      DB.request({
        url: DB.prefix + "auth/v2/hasImageVeriCode",
        success: data => {
          // this.setVerifyImg();
          if (data.data) {
            this.isShowImg = true;
          } else {
            this.isShowImg = false;
          }
        }
      });
    },
    register() {
      this.$refs["registerForm"].validate(valid => {
        if (valid) {
          this.tempError3 = true;
          this.tempError4 = true;
          this.tempError6 = true;
          this.registerPhoneCodeError = "";
          this.registerImageCodeError = "";
          this.registerNameError = "";
          this.$refs.registerForm.validateField("loginName2");
          this.$refs.registerForm.validateField("obj");
          this.$refs.registerForm.validateField("verifyCode2");
          this.loading = true;
          DB.request({
            url: DB.prefix + "auth/v2/validateRegistPhone",
            type: "POST",
            showMessage: false,
            data: {
              phone: this.registerValidate.loginName2,
              // imageVeriCode_tel: this.registerValidate.imageVeriCode2,
              ...this.registerValidate.obj,
              authCode: this.registerValidate.verifyCode2,
              saleAdmin: this.saleAdmin
            },
            success: res => {
              this.registerNameError = "";
              this.registerImageCodeError = "";
              this.registerPhoneCodeError = "";
              window.location.href = `#/register?step=2&authCode=${
                this.registerValidate.verifyCode2
              }&phone=${this.registerValidate.loginName2}&saleAdmin=${
                this.saleAdmin
              }`;
            },
            error: data => {
              this.setVerifyImg();
              if (data.errCode == "hr1007") {
                // 短信验证码无效
                this.showServerError = true;
                this.registerPhoneCodeError = data.message;
                this.$refs.registerForm.validateField("verifyCode2");
                return false;
              } else if (data.errCode == "hr0003") {
                //图片验证码验证失败
                this.showServerError = true;
                this.registerImageCodeError = data.message;
                this.$refs.registerForm.validateField("obj");
                return false;
              } else if (data.errCode == "hr5005") {
                //手机号已存在
                this.showServerError = true;
                this.registerNameError = data.message;
                this.$refs.registerForm.validateField("loginName2");
                return false;
              }
            },
            complete: () => {
              this.loading = false;
            }
          });
        }
      });
    },
    login() {
      let url = this.$route.query.url || "/index.html#/";
      //如果已经登录 这个页面直接跳
      this.$refs["loginForm"].validate(valid => {
        console.log('valid', valid);
        if (valid) {
          this.tempError1 = true;
          this.tempError2 = true;
          this.tempError5 = true;
          this.tempError6 = true;
          this.loginNameError = "";
          this.loginImageCodeError = "";
          this.loginPhoneCodeError = "";
          this.loginPasswordError = "";

          this.$refs.loginForm.validateField("loginName");
          this.$refs.loginForm.validateField("verifyCode");
          this.$refs.loginForm.validateField("passWord");
          
          if (!this.useMessageLogin) {
            //密码登录
            let linkObj;
            function getAuthorizeCode(username, password) {
              var ha1 = `${username}:${linkObj.realm || ""}:${MD5(password)}`,
                ha2 = "POST:/auth/v2/login";
              return MD5(`${MD5(ha1)}:${linkObj.nonce || ""}:${MD5(ha2)}`);
            }
            function getTwoAuthorizeCode(username, auth) {
              return getAuthorizeCode(
                username,
                MD5(auth + "5OGP56W65A6D6LSD") + "x"
              );
            }
            this.loading = true;
            DB.request({
              url: DB.prefix + "auth/v2/link",
              type: "get",
              success: data => {
                linkObj = data.data || {};
                //if(!linkObj.isLogin){
                let username = this.formValidate.loginName;
                let password = this.formValidate.passWord;
                let originPwd =
                  username.indexOf("@hunteron.com") < 0 ? "" : MD5(password);
                let authorizeCode = getAuthorizeCode(username, password);
                let twoAuthorizeCode = getTwoAuthorizeCode(
                  username,
                  authorizeCode
                );

                let params = {
                  loginName: username,
                  authorizeCode: authorizeCode,
                  originPwd: originPwd,
                  twoAuthorizeCode: twoAuthorizeCode,
                  expiredNum: this.expiredNum ? 1 : 0
                }

                if(this.formValidate.obj && Object.keys(this.formValidate.obj).length){
                  params = {
                    loginName: username,
                    authorizeCode: authorizeCode,
                    originPwd: originPwd,
                    twoAuthorizeCode: twoAuthorizeCode,
                    ...this.formValidate.obj,
                    expiredNum: this.expiredNum ? 1 : 0
                  }
                }

                DB.request({
                  url: DB.prefix + "auth/v2/login",
                  type: "POST",
                  data: params,
                  success: res => {
                    if (res.data && res.data.isLieying) {
                      url = "/ly/positions.html#/hunter/list";
                    }
                    setTimeout(() => {
                      window.location.href = url;
                    }, 500);
                  },
                  complete: () => {
                    this.loading = false;
                  },
                  error: data => {
                    // this.checkVerifyImg();
                    this.setVerifyImg();
                    if (data.errCode == "hr1019") {
                      // 用户名或密码错误
                      this.showServerError = true;
                      this.loginNameError = data.message;
                      this.$refs.loginForm.validateField("loginName");
                      return false;
                    } else if (data.errCode == "hr0003") {
                      //图片验证码验证失败
                      this.showServerError = true;
                      this.loginImageCodeError = data.message;
                      this.$refs.loginForm.validateField("obj");
                      return false;
                    } else if (data.errCode == "hr5007") {
                      //手机号不存在
                      this.showServerError = true;
                      this.loginNameError = data.message;
                      this.$refs.loginForm.validateField("loginName");
                      return false;
                    }
                  }
                });
                // }else{
                //   //直接跳转
                //   console.log('已经登录')
                //   window.location.href="/tools.html";
                // };
              },
              error: () => {
                this.loading = false;
              }
            });
          } else {
            //短信验证码登录
            this.loading = true;
            DB.request({
              url: DB.prefix + "auth/v2/smsLogin",
              type: "POST",
              data: {
                mobilePhone: this.formValidate.loginName,
                imageVerifyCode: 123,
                ...this.formValidate.obj,
                smsVerifyCode: this.formValidate.verifyCode
              },
              success: res => {
                if (res.data && res.data.isLieying) {
                  url = "/ly/positions.html#/hunter/list";
                }
                setTimeout(() => {
                  window.location.href = url;
                }, 500);
              },
              error: data => {
                if (data.errCode == "hr1007") {
                  // 短信验证码无效
                  this.showServerError = true;
                  this.loginPhoneCodeError = data.message;
                  this.$refs.loginForm.validateField("verifyCode");
                  return false;
                } else if (data.errCode == "hr0003") {
                  //图片验证码验证失败
                  this.showServerError = true;
                  this.loginImageCodeError = data.message;
                  this.$refs.loginForm.validateField("obj");
                  return false;
                } else if (data.errCode == "hr5007") {
                  //手机号不存在
                  this.showServerError = true;
                  this.loginNameError = data.message;
                  this.$refs.loginForm.validateField("loginName");
                  return false;
                }
              },
              complete: () => {
                this.loading = false;
              }
            });
          }
        }
      });
    },
    getAd() {
      DB.request({
        url: "//boot-restful.hunteron.com/news/list",
        data: {
          appType: "HR",
          clientType: "PC",
          channelId: 15,
          showOverdue: 1,
          barSort: 1,
          scheduleStatus: 1
        },
        jsonp: true,
        success: data => {
          if (data.adBeanList && data.adBeanList.length > 0) {
            let list = data.adBeanList[0].adBean;
            this.topBg = `url('${list.imageUrl}')`;
            this.imgHref = list.targetUrl || "";
          }
        }
      });
    }
  },
  created() {
    // this.checkVerifyImg();
    // new swiper('.swiper-container',{
    //   pagination: '.swiper-pagination',
    //   effect: 'fade',
    //   paginationClickable: true,
    //   preventClicks: false,
    //   autoplay: 3000,
    //   loop: true,
    //   autoplayDisableOnInteraction: false,
    // });
    // this.getAd();
  },
  mounted() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.login-page {
  .ivu-form-item-error-tip {
    color: #f8e71c !important;
    right: 0;
    left: auto;
    top: -27px;
    font-size: 14px;
    &::before {
      content: "\e641";
      color: #f8e71c;
      margin: -1px 3px 0 0;
      float: left;
      font-family: "iconfont" !important;
      font-size: 16px;
      font-style: normal;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }
  }
  .ivu-form-item-error .ivu-input {
    border-color: #f8e71c !important;
  }
  .ivu-input {
    border: 1px solid rgba(255, 255, 255, 0.3) !important;
    border-radius: 4px;
    background-color: rgba(45, 140, 240, 0) !important;
    color: #fff !important;
  }
  .ivu-input:hover {
    border-color: #fff !important;
  }
}
</style>
<style lang="scss" scoped>
.login-page {
  width: 100%;
  background-color: #eff3f6;
  .swiper-container {
    width: 100%;
    height: 770px;
    .banner {
      display: block;
      width: 100%;
      height: 770px;
      cursor: default;
    }
    .login-banner1 {
      background: url(../../assets/login/banner1.jpg) center no-repeat;
    }
    .login-banner2 {
      background: url(../../assets/login/banner2.jpg) center no-repeat;
    }
  }
  .top-wrap {
    width: 1200px;
    position: relative;
    margin: 0 auto;
    .logo {
      position: absolute;
      top: -745px;
      left: 0;
      color: #fff;
      font-size: 28px;
      line-height: 36px;
      img {
        width: 36px;
        height: 36px;
        float: left;
        margin-right: 5px;
        display: inline-block;
      }
    }
    .login-wrap {
      position: absolute;
      right: 0;
      top: -597px;
      width: 380px;
      padding: 0 20px 20px;
      background: rgba(45, 140, 240, 0.89);
      border-radius: 4px;
      .title {
        width: 100%;
        color: #fff;
        margin-bottom: 5px;
        font-size: 13px;
        span {
          opacity: 0.39;
          font-size: 20px;
          color: #ffffff;
          text-align: center;
          line-height: 30px;
          margin: 15px 0;
          display: inline-block;
          width: 49%;
          cursor: pointer;
          &.cur {
            opacity: 1;
          }
        }
      }
      .login-form {
        width: 100%;
        .form-verify-img {
          display: inline-block;
          height: 25px;
          overflow: hidden;
          position: absolute;
          right: 10px;
          top: -54px;
          padding-left: 10px;
          border-left: 1px solid rgba(255, 255, 255, 0.3);
          img {
            height: 25px;
            display: inline-block;
          }
        }
        .rel-img-wrap {
          position: relative;
        }
        .phone-img-wrap {
          position: absolute;
          right: 10px;
          top: -52px;
          a {
            line-height: 20px;
            color: #fff;
            display: inline-block;
            height: 20px;
            padding-left: 10px;
            border-left: 1px solid rgba(255, 255, 255, 0.3);
            font-size: 14px;
            &:hover {
              text-decoration: underline;
            }
          }
          .unsend {
            cursor: not-allowed;
          }
        }
      }
      .find-pwd {
        color: #fff;
        margin-bottom: 10px;
        font-size: 14px;
        a {
          color: #fff;
          &:hover {
            text-decoration: underline;
          }
        }
      }
      .text-bottom {
        color: #fff;
        font-size: 14px;
        width: 100%;
        text-align: center;
        margin-top: 10px;
        display: inline-block;
        &.underline:hover {
          text-decoration: underline;
        }
        a {
          color: #fff;
          text-decoration: underline;
        }
      }
    }
  }
}
.banner-wrap {
  width: 100%;
  background-repeat: no-repeat;
  background-position: center center;
  height: 770px;
  overflow: hidden;
  .banner-link {
    display: block;
    width: 100%;
    height: 770px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/login/index.vue